import type { PostContent } from '../types';
import { certificates } from './2026-10-certificates';
import { fleet } from './2026-10-ea-connect-fleet';

// Every What's New post. Add one file per post in this folder (named after its id) and list it here; it shows once
// user-manager has its release (user-manager's announcements/ SQL files).
export const POSTS: PostContent[] = [certificates, fleet];
